import React, { useState } from 'react';
import { validateForm } from '../../../../core/form/formValidationRules';
import usePost from '../../../../core/hooks/api/usePost';
import API_ENDPOINTS from '../../../../core/constant/API_ENDPOINTS';
import ComplaintFormPresentation from './ComplaintFormPresentation';
import BreadCrumb from '../../common/breadcrumb/breadCrumb';
import { ValidationRule } from '../../../../core/Interface/validationsInterfaces';
import { all_routes } from '../../../../core/data/routes/all_routes';
import { useNavigate } from 'react-router-dom';

const ComplaintFormContainer = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    address: '',
    dniOrCe: '',
    phoneOrEmail: '',
    tutorFullName: '',
    productOrService: '',
    totalAmount: '',
    description: '',
    complaintOrClaim: '',
    isMinor: false,
    detail: '',
    order: ''
  });

  const [errors, setErrors] = useState<any>({});
  const [requestError, setRequestError] = useState<any>(null);
  const [successRequest, setSuccessRequest] = useState<boolean>(false);
  const { post, loading } = usePost(API_ENDPOINTS.complaint);

  const routes = all_routes;
  const navigate = useNavigate();

  const validationRules: ValidationRule[] = [
    { field: 'fullName', methods: ['required'] },
    { field: 'address', methods: ['required'] },
    { field: 'dniOrCe', methods: ['required', 'isNumber'] },
    { field: 'phoneOrEmail', methods: ['required'] },
    { field: 'productOrService', methods: ['required'] },
    { field: 'totalAmount', methods: ['required', 'isNumber'] },
    { field: 'description', methods: ['required'] },
    { field: 'complaintOrClaim', methods: ['required'] },
    { field: 'detail', methods: ['required'] },
    { field: 'order', methods: ['required'] },
  ];

  const createComplaint = async (e: any, complaintData: any) => {
    e.preventDefault();
    if (complaintData.isMinor) {
      validationRules.push({ field: 'tutorFullName', methods: ['required'] });
    }

    const validationErrors = validateForm(complaintData, validationRules, {}, new Date());

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      setErrors({});
      const response = await post(complaintData);
      setSuccessRequest(true);
      navigate(routes.complaintBookSendEmail, { state: response?.data });
    } catch (error: any) {
      console.error(error);
      setSuccessRequest(false);
      setRequestError(error?.response.data);
    }
  };

  return (
    <>
      <BreadCrumb title="Libro de Reclamaciones" item1="Home" item2="Libro de Reclamaciones" />
      <div className="page-wrapper my-5">
        <div className="content">
          <div className="container">
            <div className="row">
              <div className="col-12">

                <div className="card shadow">
                  <div className="card-header bg-primary text-white">
                    <h4 className="mb-0">HOJA DE RECLAMACIÓN</h4>
                  </div>

                  <div className="card-body">
                    {/* Información del proveedor */}
                    <div className="mb-4 bg-light p-3 rounded border">
                      <h5 className="mb-3">Información del Proveedor</h5>
                      <ul className="list-unstyled mb-0">
                        <li><strong>Razón Social:</strong> LIFT COMMUNITY S.A.C.</li>
                        <li><strong>RUC:</strong> 20611385391</li>
                        <li><strong>Dirección Legal:</strong> Av. Santa Cruz Nro. 381 Int. 304, Miraflores, Lima, Perú</li>
                      </ul>
                    </div>

                    {/* Formulario */}
                    <ComplaintFormPresentation
                      formData={formData}
                      errors={errors}
                      loading={loading}
                      requestError={requestError}
                      successRequest={successRequest}
                      validationRules={validationRules}
                      createComplaint={createComplaint}
                    />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ComplaintFormContainer;